"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconGradientNames = exports.Icon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icons = require("./icons");
var _excluded = ["className", "gradientName", "name", "size"];
require("./Icon.css");
var styles = {
  "Root": "Icon-module-Root_1g8"
};
var IconGradientNames = {
  caribbeanSea: 'caribbeanSea',
  callicarpa: 'callicarpa'
};
exports.IconGradientNames = IconGradientNames;
var sizeMap = {
  m: 24,
  s: 16
};
var Icon = function Icon(_ref) {
  var _icon$name, _icon$name2;
  var className = _ref.className,
    gradientName = _ref.gradientName,
    name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var icon = _icons.icons[size];
  if (!name || !icon[name]) return null;
  var width = ((_icon$name = icon[name]) === null || _icon$name === void 0 ? void 0 : _icon$name.width) || sizeMap[size];
  var height = ((_icon$name2 = icon[name]) === null || _icon$name2 === void 0 ? void 0 : _icon$name2.height) || sizeMap[size];
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    className: (0, _classnames.default)(styles.Root, className),
    focusable: false,
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, props), name === 'ukassa' && /*#__PURE__*/_react.default.createElement("rect", {
    width: width,
    height: height,
    rx: "0",
    fill: "url(#ukassa-gradient)"
  }), icon[name].paths.map(function (_ref2) {
    var path = _ref2.path,
      fill = _ref2.fill,
      fillRule = _ref2.fillRule,
      stroke = _ref2.stroke,
      clipRule = _ref2.clipRule;
    return /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
      key: path,
      d: path
    }, stroke && {
      stroke: stroke
    }, fill && {
      fill: fill
    }, fillRule && {
      fillRule: fillRule
    }, clipRule && {
      clipRule: clipRule
    }, gradientName && !fill && {
      fill: 'url(#icon-gradient)'
    }));
  }), gradientName === 'caribbeanSea' && /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "icon-gradient",
    x1: "6.61864",
    y1: "16.83",
    x2: "14.3041",
    y2: "2.03944",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#8168F0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.137",
    stopColor: "#7F6DF0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2924",
    stopColor: "#787AF0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.4568",
    stopColor: "#6C91F1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.6273",
    stopColor: "#5DB1F1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8012",
    stopColor: "#48D9F2"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8195",
    stopColor: "#46DEF2"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#50E3C2"
  }))), gradientName === 'callicarpa' && /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "icon-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: "3.1897",
    y1: "3.8409",
    x2: "21.2006",
    y2: "21.7706"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#FF00D5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.9906",
    stopColor: "#3AA8F2"
  }))), name === 'bnpl' && /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "bnpl-gradient-1",
    x1: "-8.39574e-08",
    y1: "28.1852",
    x2: "31.2573",
    y2: "18.928",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#F8EC4F"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.567624",
    stopColor: "#4DE544"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#49C8FF"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "bnpl-gradient-2",
    x1: "28.3239",
    y1: "4.74891e-06",
    x2: "19.5638",
    y2: "14.3299",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#CDEFFD"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#91E5CB"
  }))), name === 'ukassa' && /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "ukassa-gradient",
    x1: "20",
    y1: "0",
    x2: "20",
    y2: "40",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#0160D1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#00479C"
  }))));
};
exports.Icon = Icon;